import store from "./store";
//import cache from "./cache_ls";
//import logout from "./logout";

var vc20200818 = {
 /*
  * version20200818
  * logout if version is not present or is < 20200818
  * */
  async vc20200818(app_version, to) {
    let cache_app_version = parseInt(store.getters.getAppVersion);
    if(cache_app_version == app_version){
      return;
    }

    store.commit('setAppVersion', app_version);

    if (process.env.VUE_APP_DEBUG == "true") {console.log("vc20200818", app_version, to.path);}
  }

};

export default vc20200818;

